// extracted by mini-css-extract-plugin
export default {"Content":"Layout_Content__jpLz0","Alert":"Layout_Alert__aXOCc"};